import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux'; // Import bindActionCreators
import * as jobActions from 'actions/jobActions';
import JobDetailsSummary from './JobDetailsSummary';
import { getReferenceDataRecord } from '../../selectors/referenceDataSelectors';
import { createSelector } from 'reselect';
import createCachedSelector from 're-reselect';
import { get } from 'lodash';
import { getFormValues } from 'redux-form';

const JobDetailsSummaryContainer = () => {
  const dispatch = useDispatch();
  const actions = bindActionCreators(jobActions, dispatch);

  // Use useSelector to retrieve state
  const currentJob = useSelector((state) => state.currentJob);
  const clientDetails = useSelector((state) => state.clientDetails);
  const referenceData = useSelector((state) => state.referenceData);

  const containerType = getReferenceDataRecord(
    referenceData,
    'containerTypes',
    'id',
    currentJob.treatmentTypeDetails.containerTypeId,
    'JobDetailsSummary.containerType',
  );

  const category = getReferenceDataRecord(
    referenceData,
    'jobCategories',
    'id',
    currentJob.treatmentTypeDetails.categoryId,
    'JobDetailsSummary.category',
  );

  const area = getReferenceDataRecord(
    referenceData,
    'areas',
    'id',
    currentJob.areaId,
    'JobDetailsSummary.areas',
  );

  const technician = getReferenceDataRecord(
    referenceData,
    'technicians',
    'id',
    currentJob.technicianId,
    'JobDetailsSummary.technician',
  );

  const standard = getReferenceDataRecord(
    referenceData,
    'jobStandards',
    'id',
    currentJob.treatmentDetails.standardId,
    'JobDetailsSummary.standard',
  );

  const sizeOfContainer = getReferenceDataRecord(
    referenceData,
    'sizeOfContainers',
    'id',
    currentJob.treatmentTypeDetails.sizeOfContainerId,
    'JobDetailsSummary.sizeOfContainer',
  );

  const treatmentType = (() => {
    const record = getReferenceDataRecord(
      referenceData,
      'treatmentTypes',
      'id',
      currentJob.treatmentDetails.treatmentTypeId,
      'JobDetailsSummary.treatmentType',
    );
    // Include `currentJob.jas` in the response
    return {
      ...record, // Spread existing properties from the retrieved record
      jas: currentJob.jas, // Add `jas` from `currentJob` (null if undefined)
     // treatmentTypeRet,
      packVolume: currentJob.packVolume,
    };
  })();

  return (
    <JobDetailsSummary
      {...currentJob}
      clientDetails={clientDetails}
      doNotCertify={currentJob.doNotCertify}
      containerType={containerType}
      category={category}
      area={area}
      technician={technician}
      standard={standard}
      sizeOfContainer={sizeOfContainer}
      treatmentType={treatmentType}
      actions={actions} // Pass the actions as props
    />
  );
};

export default JobDetailsSummaryContainer;
